import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { OptionService } from '../option.service';
import { CustomerRegister } from './customerRegister.model';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {

  userCategory: { id: number, name: string }[] = [];
  customerRegister:CustomerRegister = {} as CustomerRegister
  confirmPassword! :string;
  spinnerOverlay = false;
  constructor(private service: OptionService,
    private snackBar: MatSnackBar,
    private translateService:TranslateService,
    private localStorage:LocalStorageService) { }

  ngOnInit(): void {
    this.getUserCategory();
    this.customerRegister.userLoginId = this.localStorage.retrieve("userInfo").userId
  }

  getUserCategory() {
    this.service.getUserCategory().subscribe(data => {
      this.userCategory = data;
      this.customerRegister.categoryId = 1;
    }, error => {
      console.log(error)
    })
  }

  submit(){
    if(this.customerRegister.password == this.confirmPassword){
    this.spinnerOverlay = true;
    this.service.registerCustomer(this.customerRegister).subscribe(data => {
      this.openSnackBar(this.translateService.instant("createdSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },error => {
      console.log(error);
      this.spinnerOverlay = false;
      if (error.error.messageAr != undefined)
        this.openSnackBar(error.error.messageAr, 'snackBarError');
      else
        this.openSnackBar("Internal server error", 'snackBarError');
     
    });
  }
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
